import React from 'react'
import config from 'config'
import { get } from 'lodash'
import MfaQRCode from '../containers/pages/MfaQRCode/MfaQRCode'
const urlPrefix = `${config.publicPath}`

export default [
  {
    path: `${urlPrefix}/mfa/code`,
    exact: true,
    component: props => (
      <MfaQRCode
        {...props}
        params={get(props, 'match.params', {})}
      />
    ),
    routes: []
  }
]


